module.exports = __webpack_public_path__ + "static/media/img03.12362043.jpg";